import API from 'app/utils/chaiApiClient';
import { toParams } from 'app/utils/url';

const getCharacters = (ids) => {
  const params = toParams({
    ids,
  });
  return API.get(`/characters/?${params}`);
};

const fetchSituations = async (characterId) => {
  const params = toParams({
    character_id: characterId,
    page: 1,
    perPage: 20,
  });
  const response = await API.getJSON(`/situations/?${params}`);
  return response.data;
};

export default {
  getCharacters,
  fetchSituations,
};



// WEBPACK FOOTER //
// ./src/app/apis/play.js